import React from 'react';
import UIProvider from './UIProvider';
import ActivityIndicatorProvider from './ActivityIndicatorProvider';
import SessionProvider from './SessionProvider';
import ToastProvider from './ToastProvider';
import AppSettingsProvider from './AppSettingsProvider';

const Providers = ({ children }: { children: React.ReactNode }) => {
  return (
    <UIProvider>
      <ActivityIndicatorProvider>
        <SessionProvider>
          <AppSettingsProvider>
            <ToastProvider>{children}</ToastProvider>
          </AppSettingsProvider>
        </SessionProvider>
      </ActivityIndicatorProvider>
    </UIProvider>
  );
};

export default Providers;
